import { render, staticRenderFns } from "./ResourceDialog.vue?vue&type=template&id=94c0d07e&"
import script from "./ResourceDialog.vue?vue&type=script&lang=js&"
export * from "./ResourceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports